import { Injectable } from '@angular/core';
import * as firebase from 'firebase/app';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from '@angular/fire/firestore';
import { Nominee, Voter, Votes, Voted} from './nominee';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import { map } from 'rxjs/operators';
import {AngularFireStorage} from '@angular/fire/storage'; 
import { Router, NavigationExtras } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ElectService {

	noCollection: AngularFirestoreCollection<Nominee>;
  	noDoc: AngularFirestoreDocument<Nominee>;
  	noItems: Observable<Nominee[]>; 

  voterCollection: AngularFirestoreCollection<Voter>;
    voterDoc: AngularFirestoreDocument<Voter>;
    voterItems: Observable<Voter[]>; 

  voCollection: AngularFirestoreCollection<Votes>;
    voDoc: AngularFirestoreDocument<Votes>;
    voItems: Observable<Votes[]>; 

  vCollection: AngularFirestoreCollection<Voted>;
    vDoc: AngularFirestoreDocument<Voted>;
    vItems: Observable<Voted[]>; 
 constructor(
           public afs: AngularFirestore,
           private st: AngularFireStorage,
           private router: Router
  	       ) { 
    this.noCollection = this.afs.collection('nominee');
    this.voCollection = this.afs.collection('myvotes');
    this.vCollection = this.afs.collection('votedata');
    this.voterCollection = this.afs.collection('voters');
  }

getAllVotes(){
      this.vItems = this.afs.collection('votedata')
     .snapshotChanges().pipe(map(changes => {
      return changes.map(a => {
        const data = a.payload.doc.data() as Voted;
        data.id = a.payload.doc.id;
        return data; 
      });
    }));
    return this.vItems;
}

getVotes(candidate){
      this.voItems = this.afs.collection('votedata', ref => {
     return ref
     .where('vote', '==', candidate)
   })
     .snapshotChanges().pipe(map(changes => {
      return changes.map(a => {
        const data = a.payload.doc.data() as Voted;
        data.id = a.payload.doc.id;
        return data; 
      });
    }));
    return this.voItems;
}

  updateVoter(id, data){
    this.voterCollection.doc(id).update(data);
  }

getMyVotes(uid){
    this.voItems = this.afs.collection('myvotes', ref => {
     return ref
     .where('voterUid', '==', uid)
   })
     .snapshotChanges().pipe(map(changes => {
      return changes.map(a => {
        const data = a.payload.doc.data() as Votes;
        data.id = a.payload.doc.id;
        return data; 
      });
    }));
    return this.voItems;
  }

gettheVotes(){
    this.voItems = this.afs.collection('myvotes')
     .snapshotChanges().pipe(map(changes => {
      return changes.map(a => {
        const data = a.payload.doc.data() as Votes;
        data.id = a.payload.doc.id;
        return data; 
      });
    }));
    return this.voItems;
  }

  getMyVoteData(uid){
    this.vItems = this.afs.collection('votedata', ref => {
     return ref
     .where('voterUid', '==', uid)
   })
     .snapshotChanges().pipe(map(changes => {
      return changes.map(a => {
        const data = a.payload.doc.data() as Voted;
        data.id = a.payload.doc.id;
        return data; 
      });
    }));
    return this.vItems;
  }
  getAllofVoter(){
    this.voterItems = this.afs.collection('voters', ref => {
      return ref.orderBy('district').orderBy('fullName', 'asc')
    })
     .snapshotChanges().pipe(map(changes => {
      return changes.map(a => {
        const data = a.payload.doc.data() as Voter;
        data.id = a.payload.doc.id;
        return data; 
      });
    }));
    return this.voterItems;
  }

  getAllVoter(){
    this.voterItems = this.afs.collection('voters', ref => {
      return ref.orderBy('isApproved', 'asc')
    })
     .snapshotChanges().pipe(map(changes => {
      return changes.map(a => {
        const data = a.payload.doc.data() as Voter;
        data.id = a.payload.doc.id;
        return data; 
      });
    }));
    return this.voterItems;
  }

getNo(){
   this.noItems = this.afs.collection('nominee', ref => {
   	return ref
   	.orderBy('fullName', 'asc')
   })
     .snapshotChanges().pipe(map(changes => {
      return changes.map(a => {
        const data = a.payload.doc.data() as Nominee;
        data.id = a.payload.doc.id;
        return data; 
      });
    }));
    return this.noItems;
  }

getVoter(phoneNumber){
   this.voterItems = this.afs.collection('voters', ref => {
     return ref
     .where('phoneNumber', '==', phoneNumber)
   })
     .snapshotChanges().pipe(map(changes => {
      return changes.map(a => {
        const data = a.payload.doc.data() as Voter;
        data.id = a.payload.doc.id;
        return data; 
      });
    }));
    return this.voterItems;
  }

getActiveVoter(phoneNumber){
   this.voterItems = this.afs.collection('voters', ref => {
     return ref
     .where('phoneNumber', '==', phoneNumber)
     .where('isApproved', '==', true)
   })
     .snapshotChanges().pipe(map(changes => {
      return changes.map(a => {
        const data = a.payload.doc.data() as Voter;
        data.id = a.payload.doc.id;
        return data; 
      });
    }));
    return this.voterItems;
  }
   addVotes(data){
     this.voCollection.doc().set(data);
   }

   addVoter(uid,data){
     this.voterCollection.doc(uid).set(data);
   }

}
